import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';

const ProjectSpotlight = ({ project, isLoading }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
    >
      <Card className="bg-slate-800/70 border-slate-700 shadow-xl h-full">
        <CardHeader>
          <CardTitle className="text-xl text-slate-200">Project Spotlight</CardTitle>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <div className="space-y-4 animate-pulse">
              <div className="h-6 bg-slate-700 rounded w-3/4"></div>
              <div className="h-4 bg-slate-700 rounded w-full"></div>
              <div className="h-4 bg-slate-700 rounded w-5/6"></div>
              <div className="h-2.5 bg-slate-700 rounded-full w-full mt-2"></div>
              <div className="h-3 bg-slate-700 rounded w-1/4 float-right"></div>
            </div>
          ) : project ? (
            <>
              <h3 className="text-lg font-semibold text-blue-400 mb-2">{project.name}</h3>
              <p className="text-sm text-slate-300 mb-4 line-clamp-2">{project.description || "No description available."}</p>
              <div className="w-full bg-slate-700 rounded-full h-2.5 mb-1">
                <div 
                  className="bg-gradient-to-r from-blue-500 to-purple-600 h-2.5 rounded-full transition-all duration-500 ease-out" 
                  style={{ width: `${project.progress || 0}%` }}
                ></div>
              </div>
              <p className="text-xs text-slate-400 text-right">{Math.round(project.progress || 0)}% Complete</p>
            </>
          ) : (
             <p className="text-slate-400 text-center py-4">No projects to spotlight currently.</p>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default ProjectSpotlight;